import { IS_LOGGED_IN } from 'constants/app';

export default function setIsLoggedIn(value: boolean) {
  localStorage.setItem(IS_LOGGED_IN, JSON.stringify(value));
}
